import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { loadLang } from '@/lang/index'
import { registerIcons } from '/@/utils/common'
import ElementPlus from 'element-plus'
import mitt from 'mitt'
import pinia from '@/store/index'
import { directives } from '/@/utils/directives'
import Table from '@pureadmin/table'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/display.css'
import 'font-awesome/css/font-awesome.min.css'
import '@/style/tailwind.css'
import '@/style/index.scss'
import '@/style/reset.scss'
import './assets/iconfont/iconfont.css' // 导入字体图标
import './assets/iconfont/iconfont.js' // 全局注册@iconify/vue图标库
import './assets/ali-iconfont/iconfont.css' // 阿里 iconfont 本地版
// 注册本地离线 Iconify 图标（包含 ri/search-line 等）
import '@/components/ReIcon/src/offlineIcon'

// 全局注册vue-tippy
import 'tippy.js/dist/tippy.css'
import 'tippy.js/themes/light.css'
import VueTippy from 'vue-tippy'
import { MotionPlugin } from '@vueuse/motion'

import { FontIcon, IconifyIconOffline, IconifyIconOnline } from './components/ReIcon'

// 全局错误处理 - 捕获未处理的错误
window.addEventListener('error', (event) => {
	// console.error('🔴 全局错误捕获：')
	// console.error('错误信息：', event.message)
	// console.error('错误文件：', event.filename)
	// console.error('错误行号：', event.lineno, '列号：', event.colno)
	// console.error('错误对象：', event.error)
	if (event.error && event.error.stack) {
		// console.error('错误堆栈：\n', event.error.stack)
	}
})

// 捕获未处理的 Promise 拒绝
window.addEventListener('unhandledrejection', (event) => {
	// console.error('🔴 未处理的 Promise 错误：')
	// console.error('原因：', event.reason)
	if (event.reason && event.reason.stack) {
		// console.error('错误堆栈：\n', event.reason.stack)
	}
	// 如果是模块加载失败
	if (event.reason && event.reason.message && event.reason.message.includes('Failed to fetch dynamically imported module')) {
		// console.error('🔍 这是一个动态模块加载失败错误')
		// console.error('可能的原因：')
		// console.error('  1. 文件路径错误（相对路径 ./ 或 ../ 错误）')
		// console.error('  2. 文件不存在')
		// console.error('  3. 文件内有语法错误')
		// console.error('  4. 导入的组件未正确注册')
		// console.error('请检查浏览器 Network 标签，查看是哪个文件加载失败（状态码 404）')
	}
})

// initialize()
// console.log('router', router.options.routes)
// modules import mark, Please do not remove.

async function start() {
	const app = createApp(App)

	// 警告处理
	app.config.warnHandler = (_msg, _instance, _trace) => {
		// console.warn('追踪：', _trace)
	}

	app.use(pinia)

	// // 全局语言包加载
	await loadLang(app)

	// 初始化应用，加载路由信息
	app.use(router)
	//  console.log('router',router.options.routes)
	app.use(ElementPlus)
	app.use(Table) // PureTable 组件
	//  全局注册
	directives(app) // 指令
	registerIcons(app) // icons
	app.component('IconifyIconOffline', IconifyIconOffline)
	app.component('IconifyIconOnline', IconifyIconOnline)
	app.component('FontIcon', FontIcon)
	app.use(VueTippy)
	app.use(MotionPlugin)
	app.mount('#app')
	app.config.globalProperties.eventBus = mitt()
}
start()
